<audio
    #audioPlayer
    [src]="sanitizeUrl(url)"
    controlsList="nodownload"
    [controls]="hasControls"
    [class.has-controls]="hasControls"
    (pause)="pause()"
    (ended)="donePlaying(true)"
    (play)="onPlayLog()"
    [attr.aria-label]="hasControls ? getAccessibleLabel() : null"
    [attr.aria-hidden]="hasControls ? null : 'true'"
>
    Your browser does not support audio playback.
</audio>
    
    
<!-- <plyr plyrTitle=""
      *ngIf="hasControls"
      [plyrType]="audio"
      [plyrPlaysInline]="false"
      [plyrOptions]="plyrOptions"
      [plyrSources]="getAudioSources()"
      plyrCrossOrigin="anonymous"
></plyr> -->
